export const handleDeleteContextNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    contexts: {
      input: [],
    },
  }));
};

export const handleDeletePhraseNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    phrases: [],
  }));
};

export const handleDeleteEventNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    events: [],
  }));
};

export const handleDeleteConditionalResponsesNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    conditional_responses: [],
  }));
};
export const handleDeleteResponses = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    responses: [],
  }));
};
export const handleDeleteConstexResponses = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    contexts: {
      output: [],
    },
  }));
};

export const handleResponseIntentNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    responses: [],
    conditional_responses: [],
    contexts: {
      output: [],
    },
  }));
};

export const handleParamsIntentNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    parameters: [],
  }));
};

export const handleExtensionIntentNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    extensions: {},
  }));
};

export const handleIntegrationIntentNode = (updateIntent) => {
  updateIntent?.((prevIntent) => ({
    ...prevIntent,
    desks: null,
  }));
};

export const handleDeleteInputNode = (updateIntent) => {
  handleDeleteContextNode(updateIntent);
  handleDeletePhraseNode(updateIntent);
  handleDeleteEventNode(updateIntent);
};
